/**
 * jsidea.core
 *
 * @license Copyright (c) jsidea
 *
 */

"use strict";

import * as jsidea from "./core.esm.js";

window.jsidea = jsidea;

jsidea.ready(() => {
    if ((window as any).jsideaWphook) {
        console.warn("jsidea hook already executed");
        return;
    }

    document.addEventListener(
        "load",
        (event) => {
            if (event.target instanceof HTMLImageElement) {
                event.target.classList.add("jsidea--loaded");
            }
        },
        true
    );
    document.querySelectorAll("img").forEach((img) => {
        if (img.complete) {
            img.classList.add("jsidea--loaded");
        }
    });

    if (jsidea.WordPressHook.supported) {
        new jsidea.WordPressHook();
    }
});
